import React from 'react';
import { AmplifyAuthentication } from '../../shared/AmplifyAuthentication';
import ErrorBoundary from '../../v2BaseComponents/ErrorBoundary';

export const SignUpScreen: React.FC = () => {
    return (
        <ErrorBoundary>
            <AmplifyAuthentication state="signUp" />
        </ErrorBoundary>
    );
};
